module.exports = __webpack_public_path__ + "img/2025-0423-01-01.a64bb9d8.png";